import React from 'react';
import { getOrderNumberParts } from './OrderNumberPrintService';

interface Props {
    orderNumber: string;
}

export const OrderNumberLastPartPrint: React.FC<Props> = ({ orderNumber }) => {
    const parts = getOrderNumberParts(orderNumber);
    const lastPart = parts[parts.length - 1];

    return <>{lastPart.text}</>;
};
